import styled from 'styled-components'

import { Accordion, fromMd } from '@syconium/little-miss-figgy'

export const PageSectionAccordionWrapper = styled.div<{ maxWidth?: number }>`
  display: flex;
  margin: auto;
  width: 100%;
  max-width: ${o => o.maxWidth && `${o.maxWidth}px`};
  border-top: 1px solid ${o => o.theme.color.deprecated.stoneLight};
  border-bottom: 1px solid ${o => o.theme.color.deprecated.stoneLight};
`

export const PageSectionAccordionHeader = styled(Accordion.Header)<{ $flush: boolean }>`
  padding: ${o => (o.$flush ? o.theme.spacing(6, 0) : o.theme.spacing(6, 2))};
  ${fromMd} {
    padding: ${o => (o.$flush ? o.theme.spacing(6, 0) : o.theme.spacing(6))};
  }
`

export const PageSectionAccordionBody = styled(Accordion.Body)`
  padding-left: 16px;
  padding-right: 16px;
`
